import Vue from 'vue'

import { list, show, update, create, remove } from './itemServices'

const state = {
  item: {},
  items: [],
  isItemLoading: false,
  isItemCreated: false,
}

const getters = {
  item: (state) => state.item,
  items: (state) => state.items,
  isItemLoading: (state) => state.isItemLoading,
  isItemCreated: (state) => state.isItemCreated,
}

const actions = {
  async fetchItem({ commit, dispatch }, itemId) {
    commit('setIsItemLoading', true)

    try {
      const { data } = await show(itemId)
      commit('setItem', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemLoading', false)
    }
  },

  async fetchItems({ commit, dispatch, rootState }, searchTerm) {
    !searchTerm && commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = {
      ...defaultParams,
      ...rootState.filters.filters
    }

    if (searchTerm) {
      params['search'] = searchTerm
    }

    try {
      const { data } = await list(params)
      const { result, total } = data

      commit('setItems', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async createEditItem({ commit, dispatch }, item) {
    commit('setIsItemLoading', true)

    try {
      if (item.id) await update(item)
      else await create(item).then(({ data }) => commit('setItem', data))

      commit('closeAllModals')
      dispatch('fetchItems')
      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate(
          item.id
            ? 'item.messages.successfullyUpdated'
            : 'item.messages.successfullyCreated'
        )
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemLoading', false)
    }
  },

  async removeItem({ commit, dispatch }, itemId) {
    commit('setIsItemLoading', true)

    try {
      await remove(itemId)

      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate('item.messages.successfullyDeleted')
      )
      dispatch('fetchItems')
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemLoading', false)
    }
  },

  handleOpenCreateEditItemModal({ dispatch, commit }, itemId) {
    commit('setItem', null)
    dispatch('openModal', 'CREATE_EDIT_ITEM_MODAL')
    itemId && dispatch('fetchItem', itemId)
  },

  handleDeleteItemModal({ dispatch, commit }, itemId) {
    commit('setItem', null)
    dispatch('openModal', 'DELETE_ITEM_MODAL')
    itemId && dispatch('fetchItem', itemId)
  },
}

const mutations = {
  setItem: (state, item) => {
    state.item = item
  },

  setItems: (state, items) => {
    state.items = items
  },

  setIsItemLoading: (state, status) => {
    state.isItemLoading = status
  },

  setIsItemCreated: (state, status) => {
    state.isItemCreated = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
